
/**
 * AlphaCharge
 * @constructor
 */
import Modaal from "modaal";
class Healing {
  constructor() {

  }
  /**
   * サンプル
   */
  init() {
    $(".video-healing").modaal({type:'video'});
    $(".video-healingdrink").modaal({type:'video'});
    
    $(function() {
      var cloud1 = $('.js-clond01');
      var cloud2 = $('.js-clond02');
      var speed = 3000;
      cloudMove();
      setInterval(cloudMove, 6000);
      function cloudMove(){
        cloud1
              .animate({backgroundPosition:'-50px'}, speed)
              .animate({backgroundPosition:'0'}, speed);
        cloud2
              .animate({backgroundPosition:'-80px'}, speed)
              .animate({backgroundPosition:'0'}, speed);
      }
  });

  }

};

export default Healing;